export const GET_FLASH_INFO = 'GET_FLASH_INFO';
export const GET_FLASH_INFO_SUCCESS = 'GET_FLASH_INFO_SUCCESS';
export const GET_FLASH_INFO_FAIL = 'GET_FLASH_INFO_FAIL';
